import React, { useContext, useState } from 'react';
import { HeaderNavigation, ALIGN, StyledNavigationList, StyledNavigationItem } from 'baseui/header-navigation';
import { AppContext, UserContext, LUDO_STAGE_HEADER_STYLE, LUDO_PROD_HEADER_STYLE } from 'commons-ui';
import { ENVIRONMENT, CURRENT_ENV } from '../constants';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from 'baseui/modal';
import { useStyletron } from 'baseui';
import { getStageEnvId, setStageEnvId, findStageEnvId } from '../utils/token';

import powerOff from '../assets/misc/powerOff.png';
import ZUPEE_LOGO from '../assets/misc/zupeeLogo.png';
import RUMMY_LOGO from '../assets/misc/rummyLogo.png';

const isStaging: boolean = CURRENT_ENV !== ENVIRONMENT.PRODUCTION;

const AppBarLayout: React.FC<{}> = () => {
	const { logoutUser, user } = useContext(UserContext);
	const [css] = useStyletron();
	const { app } = useContext(AppContext);
	const imageStyle = css({ marginRight: '5px' });
	const [showNsModal, setShowNsModal] = useState(false);
	const [nsInput, setNsInput] = useState('');

	const handleSignoutClick = (e: any) => {
		e.preventDefault();
		logoutUser();
	};

	const logo = app.appName !== 'com.android.tezrummy' ? ZUPEE_LOGO : RUMMY_LOGO;
	const logoHeight = app.appName !== 'com.android.tezrummy' ? '45px' : '80px';

	const headerStyle = () => {
		switch (app.appName) {
			case 'in.ludo.supremegold':
				if (CURRENT_ENV === ENVIRONMENT.PRODUCTION) {
					return LUDO_PROD_HEADER_STYLE;
				}
				return LUDO_STAGE_HEADER_STYLE;
			default:
				if (CURRENT_ENV === ENVIRONMENT.PRODUCTION) {
					return LUDO_PROD_HEADER_STYLE;
				}
				return LUDO_STAGE_HEADER_STYLE;
		}
	};

	return (
		<div>
			<HeaderNavigation
				overrides={{
					Root: {
						style: () => ({
							height: '60px',
							...headerStyle()
						})
					}
				}}>
				<StyledNavigationList $align={ALIGN.left}>
					<StyledNavigationItem>
						<img height={logoHeight} src={logo} alt='zupee-logo' />
					</StyledNavigationItem>
					<StyledNavigationItem
						$style={{
							display: 'flex',
							alignItems: 'center',
							height: '100%',
							position: 'relative',
							top: app.appName === 'com.android.tezrummy' ? '-2px' : '-4px'
						}}>
						{user?.userName}
					</StyledNavigationItem>
					{isStaging && (
						<StyledNavigationItem>
							<Button
								size='mini'
								kind='secondary'
								onClick={() => {
									setNsInput(getStageEnvId() || '');
									setShowNsModal(true);
								}}
								overrides={{
									BaseButton: { style: { fontSize: '11px', paddingTop: '4px', paddingBottom: '4px' } }
								}}>
								Namespace: <span style={{ backgroundColor: '#fef08a', padding: '0 4px', borderRadius: '3px', fontWeight: 700 }}>{getStageEnvId() || 'default'}</span>
							</Button>
						</StyledNavigationItem>
					)}
				</StyledNavigationList>
				<StyledNavigationList $align={ALIGN.center}>
					<StyledNavigationItem $style={{ textTransform: 'uppercase', marginRight: '15%' }}>
						{CURRENT_ENV}
					</StyledNavigationItem>
				</StyledNavigationList>
				<StyledNavigationList $align={ALIGN.right}>
					<StyledNavigationItem>
						<Button onClick={handleSignoutClick} size='compact'>
							<img className={imageStyle} src={powerOff} alt='power-off' />
							Sign Out
						</Button>
					</StyledNavigationItem>
				</StyledNavigationList>
			</HeaderNavigation>
			{isStaging && (
				<Modal isOpen={showNsModal} onClose={() => setShowNsModal(false)}>
					<ModalHeader>Change Namespace</ModalHeader>
					<ModalBody>
						<p style={{ fontSize: '13px', color: '#6b7280', marginTop: 0 }}>
							Default: <strong>{findStageEnvId() || 'unknown'}</strong>
						</p>
						<Input
							value={nsInput}
							onChange={(e) => setNsInput(e.currentTarget.value)}
							placeholder='Enter namespace'
							onKeyDown={(e) => {
								if (e.key === 'Enter' && nsInput.trim()) {
									setStageEnvId(nsInput.trim());
									setShowNsModal(false);
								}
							}}
						/>
					</ModalBody>
					<ModalFooter>
						<ModalButton
							kind='tertiary'
							onClick={() => {
								setStageEnvId(findStageEnvId() || '');
								setShowNsModal(false);
							}}>
							Reset to Default
						</ModalButton>
						<ModalButton
							onClick={() => {
								if (nsInput.trim()) {
									setStageEnvId(nsInput.trim());
								}
								setShowNsModal(false);
							}}>
							Apply
						</ModalButton>
					</ModalFooter>
				</Modal>
			)}
		</div>
	);
};

export default AppBarLayout;
